export enum PasswordStrengthEnum {
  empty = 'empty',
  error = 'error',
  weak = 'weak',
  strong = 'strong',
}
